import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { activityAsMemberQueryKeys } from "./activityAsMemberQueryKeys";

export async function activityCategoryListAsMemberQueryFn({
  api,
  filter,
}: {
  api: ApiType;
  filter: Parameters<ApiType["customerActivityApi"]["findCategories"]>[0];
}) {
  const result = await api.customerActivityApi.findCategories(filter);
  return result.data;
}

export function useQueryActivityCategoryListAsMember(
  {
    api,
    filter,
  }: {
    api: ApiType;
    filter: Parameters<ApiType["customerActivityApi"]["findCategories"]>[0];
  },
  {
    enabled,
  }: {
    enabled?: boolean;
  } = {
    enabled: true,
  },
) {
  return useQuery({
    queryKey: activityAsMemberQueryKeys.categories(filter),
    queryFn: () => activityCategoryListAsMemberQueryFn({ api, filter }),
    enabled,
  });
}
